(function() {
    const DEBUG_MODE = false; // Set to false for production
    let cartDrawerSectionId = null;
    let cartPageSectionId = null; // Added for cart page section
  
    function logDebug(...args) {
      if (DEBUG_MODE) {
        console.log('[LOGEIX Cart Sync]', ...args);
      }
    }
  
    function logWarn(...args) {
      if (DEBUG_MODE) {
        console.warn('[LOGEIX Cart Sync]', ...args);
      }
    }
  
    function logError(...args) {
      console.error('[LOGEIX Cart Sync]', ...args);
    }
  
    // Flag to prevent re-entry if our script is already updating the cart
    let isUpdatingCartBySync = false;
  
    function getLineItemProperty(item, propertyName) {
      if (item && item.properties) {
        // Handle cases where property keys might have leading/trailing spaces from Shopify
        for (const key in item.properties) {
          if (key.trim() === propertyName) {
            return item.properties[key];
          }
        }
      }
      return null;
    }
  
    function findCartDrawerSectionId() {
      const cartDrawerElement = document.querySelector('hdt-cart-drawer');
      if (cartDrawerElement) {
        cartDrawerSectionId = cartDrawerElement.getAttribute('section-id');
        logDebug('Found cart drawer section ID:', cartDrawerSectionId);
      } else {
        logWarn('Cart drawer element (hdt-cart-drawer) not found. Section-specific UI updates might not work optimally for drawer.');
      }
    }
  
    function findCartPageSectionId() {
      // The theme's CartPageForm gets its section_id from the <form> element within it.
      const cartPageFormElement = document.querySelector('wrapp-hdt-cart-page-form form[section-id]');
      if (cartPageFormElement) {
        cartPageSectionId = cartPageFormElement.getAttribute('section-id');
        logDebug('Found cart page section ID:', cartPageSectionId);
      } else {
        // It's okay if this isn't found when not on the cart page.
        // logWarn('Cart page form element (wrapp-hdt-cart-page-form form[section-id]) not found.');
      }
    }
  
    logDebug('Hiding logic needs to be theme-specific or CSS-based. CSS will be added to lgx-custom.css.liquid.');
    // Actual JS hiding can be added here if CSS proves insufficient, once theme cart structure is known.
    
    // Helper to find identifiers from an event target
    function getItemIdentifiersFromTarget(target) {
        logDebug('[getItemIdentifiers] Initial target:', target.tagName, '.', target.className, 'id:', target.id, 'Name:', target.name);
        let itemKey = null;
        let lineIndexStr = null; // Store as string initially

        const quantityWrapper = target.closest('hdt-quantity-wrapp');
        const removeWrapper = target.closest('wrapp-remove-item-oncart');

        if (quantityWrapper) { // For +/- buttons or direct input change within hdt-quantity-wrapp
            const input = quantityWrapper.querySelector('input');
            if (input) {
                itemKey = input.dataset.key || input.name.match(/updates\\[(.*?) \\]/)?.[1];
                lineIndexStr = input.dataset.index; 
                logDebug('[getItemIdentifiers] Quantity wrapper. Input found. Key:', itemKey, 'LineIndexStr:', lineIndexStr);
            } else {
                logDebug('[getItemIdentifiers] Quantity wrapper found, but no input inside.');
            }
        } else if (removeWrapper) { // For remove buttons
            itemKey = removeWrapper.dataset.key || removeWrapper.getAttribute('data-key');
            lineIndexStr = removeWrapper.dataset.index || removeWrapper.getAttribute('data-index');
            logDebug('[getItemIdentifiers] Remove wrapper. Key:', itemKey, 'LineIndexStr:', lineIndexStr);
            
            // Fallback for remove wrapper if key/index not directly on it
            if (!itemKey && !lineIndexStr) {
                const cartItemElKey = removeWrapper.closest('[data-cart-item-key]');
                if (cartItemElKey) itemKey = cartItemElKey.dataset.cartItemKey;
                
                const cartItemElIndex = removeWrapper.closest('[data-line-index]'); // A common pattern to have line index on the row
                if (cartItemElIndex && !lineIndexStr) lineIndexStr = cartItemElIndex.dataset.lineIndex;
                logDebug('[getItemIdentifiers] Remove wrapper fallback. Key:', itemKey, 'LineIndexStr:', lineIndexStr);
            }
        } else if (target.matches('input[name^="updates["], input[data-index]')) { 
            // For inputs not necessarily within hdt-quantity-wrapp but still part of the cart form
            itemKey = target.dataset.key || target.name.match(/updates\\[(.*?) \\]/)?.[1];
            lineIndexStr = target.dataset.index;
            logDebug('[getItemIdentifiers] Direct input match. Key:', itemKey, 'LineIndexStr:', lineIndexStr, 'Input Value:', target.value);
        } else {
            logDebug('[getItemIdentifiers] Target did not match known cart item interactive elements. Target details above.');
        }
        
        return { key: itemKey, line: lineIndexStr };
    }
  
    async function handlePotentialLinkedItemChange(event) {
        logDebug('[ProactiveHandler] Entered function. Event type:', event.type, 'Explicit Event Target:', event.target, 'CurrentTarget:', event.currentTarget);
        if (isUpdatingCartBySync) { 
            logDebug('[ProactiveHandler] Already updating cart by sync, skipping event:', event.type, event.target.tagName, event.target.className);
            return;
        }
        const target = event.target;
        const identifiers = getItemIdentifiersFromTarget(target);
        let itemKey = identifiers.key;
        const lineIndexStr = identifiers.line; 

        if (!itemKey && !lineIndexStr) {
            logDebug('[ProactiveHandler] No key or line index found for target. Letting theme handle. Target:', target.tagName, target.className, target.id);
            return;
        }

        logDebug('[ProactiveHandler] Potential linked item change. Event:', event.type, 'Target:', target.tagName, '.',target.className, 'IDs found: key=', itemKey, 'line=', lineIndexStr);

        // Fetch current cart
        let cart;
        try {
            const response = await fetch(`${Shopify.routes.root}cart.js`);
            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
            cart = await response.json();
            if (!cart || !cart.items) throw new Error('Invalid cart data received');
            logDebug('[ProactiveHandler] Fetched cart.js successfully. Item count:', cart.items.length);
        } catch (error) {
            logError('[ProactiveHandler] Failed to fetch or parse cart.js:', error);
            return; // Let theme handle if we can't get cart state
        }

        let changedItem = null;
        if (itemKey) {
            changedItem = cart.items.find(item => item.key === itemKey);
            if (changedItem) logDebug('[ProactiveHandler] Found item by key:', itemKey);
        }
        
        if (!changedItem && lineIndexStr) {
            const lineNum = parseInt(lineIndexStr, 10);
            if (!isNaN(lineNum) && lineNum > 0 && lineNum <= cart.items.length) {
                changedItem = cart.items[lineNum - 1]; 
                if (changedItem) {
                    itemKey = changedItem.key; // Ensure itemKey is populated if found by line index
                    logDebug(`[ProactiveHandler] Resolved item via lineIndex ${lineIndexStr} to key ${itemKey}. Title: ${changedItem.title}`);
                } else {
                     logWarn('[ProactiveHandler] Line index valid, but item not found at cart.items[', lineNum - 1, ']');
                }
            } else {
                logWarn('[ProactiveHandler] Invalid lineIndexStr or out of bounds:', lineIndexStr, 'Cart items:', cart.items.length);
            }
        }
        
        if (!changedItem || !itemKey) {
            logDebug('[ProactiveHandler] Could not definitively identify changed item from cart using key/line. Letting theme handle.');
            return;
        }

        const linkingIdProperty = getLineItemProperty(changedItem, '_Personalisation Linking ID');
        if (!linkingIdProperty) {
            logDebug('[ProactiveHandler] Item (key:', itemKey, `title: ${changedItem.title}) is NOT a linked personalisation item (missing _Personalisation Linking ID). Letting theme handle.`);
            return; 
        }

        logDebug('[ProactiveHandler] Confirmed linked item change for key:', itemKey, 'Item:', changedItem.title, '_Personalisation Linking ID:', linkingIdProperty, 'Event type:', event.type);
        
        // Prevent other listeners FOR THIS SPECIFIC EVENT (click or change on the form)
        event.preventDefault(); 
        event.stopImmediatePropagation(); 

        isUpdatingCartBySync = true; 

        const updates = {};
        const linkingId = linkingIdProperty; // Already fetched
        let newQuantity;

        // Determine new quantity
        const inputElement = target.closest('hdt-quantity-wrapp')?.querySelector('input[data-index]');
        if (event.type === 'click' && target.matches('.hdt-quantity__button')) { // Click on +/-
            if (inputElement) {
                let currentVal = parseInt(inputElement.value, 10);
                const step = parseInt(inputElement.step, 10) || 1;
                if (target.matches('.hdt-quantity__button[name="minus"]')) {
                    newQuantity = Math.max(parseInt(inputElement.min, 10) || 0, currentVal - step);
                } else { // Plus button
                    newQuantity = Math.min(parseInt(inputElement.max, 10) || 9999, currentVal + step);
                }
                logDebug(`[ProactiveHandler] +/- button click. Derived new Qty: ${newQuantity} from currentVal: ${currentVal}`);
            } else {
                logError('[ProactiveHandler] Click on +/- button, but could not find associated input element to derive quantity.');
                isUpdatingCartBySync = false; return;
            }
        } else if (event.type === 'click' && target.closest('wrapp-remove-item-oncart')) { // Click on remove
            newQuantity = 0;
            logDebug(`[ProactiveHandler] Item ${changedItem.title} (key ${itemKey}) removal initiated.`);
        } else if (event.type === 'change' && inputElement && target === inputElement) { // Change event directly on the quantity input
            newQuantity = parseInt(inputElement.value, 10);
            logDebug(`[ProactiveHandler] Quantity input change event. New Qty from input: ${newQuantity}`);
        } else {
            logWarn('[ProactiveHandler] Could not determine action for quantity derivation. Target:', target, 'Event type:', event.type);
            // Attempt to use value from target if it's an input, otherwise, this path might be problematic
            if (target.tagName === 'INPUT' && typeof target.value !== 'undefined') {
                 newQuantity = parseInt(target.value, 10);
                 logWarn(`[ProactiveHandler] Fallback: using target.value for newQuantity: ${newQuantity}`);
            } else {
                logError('[ProactiveHandler] Unhandled case for quantity derivation. Cannot proceed.');
                isUpdatingCartBySync = false; return;
            }
        }

        if (isNaN(newQuantity)) {
            logError('[ProactiveHandler] Could not determine a valid new quantity for item:', changedItem.title, 'Derived value was NaN.');
            isUpdatingCartBySync = false;
            return;
        }
        logDebug(`[ProactiveHandler] Item ${changedItem.title} (key ${itemKey}) quantity to be set to: ${newQuantity}`);
        
        updates[itemKey] = newQuantity;

        // Find and update linked item
        cart.items.forEach(item => {
            if (item.key !== itemKey && getLineItemProperty(item, '_Personalisation Linking ID') === linkingId) {
                logDebug(`Linked item ${item.title} (key ${item.key}) will also be updated to quantity ${newQuantity}`);
                updates[item.key] = newQuantity;
            }
        });

        if (Object.keys(updates).length > 0) {
            logDebug('Making combined update for linked items:', updates);
            try {
                const requestBody = { updates };
                const sectionsToRequest = [];
                if (cartDrawerSectionId) sectionsToRequest.push(cartDrawerSectionId);
                if (cartPageSectionId && window.location.pathname.includes('/cart')) {
                    if (!sectionsToRequest.includes(cartPageSectionId)) sectionsToRequest.push(cartPageSectionId);
                }
                if (sectionsToRequest.length > 0) {
                    requestBody.sections = sectionsToRequest;
                    requestBody.sections_url = window.location.pathname;
                }

                const response = await fetch(`${Shopify.routes.root}cart/update.js`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(requestBody)
                });
                const updatedCartData = await response.json();

                if (!response.ok) {
                    logError('Combined cart/update.js failed:', updatedCartData.message || updatedCartData.description || 'Unknown error');
                } else {
                    logDebug('Combined cart/update.js successful. Response cart:', updatedCartData);
                    document.dispatchEvent(new CustomEvent("cart:change", {
                        bubbles: true,
                        detail: {
                            baseEvent: "cart:sync:combined_update",
                            cart: updatedCartData,
                            request_url: window.location.pathname,
                            source: "lgx-cart-sync" // Important: mark as our own event
                        }
                    }));
                    logDebug('Dispatched cart:change after combined update.');
                }
            } catch (error) {
                logError('Error in combined cart/update.js call:', error);
            } finally {
                setTimeout(() => {
                  isUpdatingCartBySync = false;
                  logDebug('isUpdatingCartBySync flag reset after combined update attempt.');
                }, 750); 
            }
        } else {
            logWarn('No updates determined for linked item change. This should not happen if interception was correct.');
            isUpdatingCartBySync = false;
        }
    }
  
    async function synchroniseCartItems(cart) {
      if (!cart || !cart.items) {
        logWarn('Cart data not available for synchronisation.');
        return;
      }
      if (isUpdatingCartBySync) {
        logDebug('Already updating cart via sync, skipping this event.');
        return;
      }
      logDebug('Starting cart quantity synchronisation. Items:', cart.items.map(i=>({key:i.key, title:i.title, qty:i.quantity, props:i.properties})) );
  
      const updates = {};
      const mainPersonalisableItems = [];
      const upsellItemsMap = new Map(); // Using item.key as the map key for upsells
  
      for (const item of cart.items) {
        const linkingId = getLineItemProperty(item, '_Personalisation Linking ID');
        const isActive = getLineItemProperty(item, '_Personalisation Active');
        // Rely on theme adding data-cart-item-is-upsell="true" or similar for CSS hiding.
        // Here, we still need to identify which item *is* the upsell for quantity sync.
        const isUpsellProperty = getLineItemProperty(item, '_Is Personalisation Upsell');

        if (linkingId) {
          if (isActive === 'true' && isUpsellProperty !== 'true') { // Main personalisable item
            mainPersonalisableItems.push({ key: item.key, variant_id: item.variant_id, quantity: item.quantity, linking_id: linkingId, title: item.title });
          } else if (isUpsellProperty === 'true') { // Upsell item, identified by its property
            upsellItemsMap.set(item.key, { key: item.key, variant_id: item.variant_id, quantity: item.quantity, linking_id: linkingId, title: item.title });
          }
        }
      }
      logDebug('Main personalisable items found:', mainPersonalisableItems.length, 'Upsell items map size:', upsellItemsMap.size);
  
      mainPersonalisableItems.forEach(mainItem => {
        let correspondingUpsellKey = null;
        upsellItemsMap.forEach((upsellDetails, mapKey) => {
          if (upsellDetails.linking_id === mainItem.linking_id) {
            correspondingUpsellKey = mapKey; // mapKey is the upsell item.key
            if (upsellDetails.quantity !== mainItem.quantity) {
              logDebug(`Qty mismatch for LID ${mainItem.linking_id} (Main: ${mainItem.title}, Upsell: ${upsellDetails.title}). Main Qty: ${mainItem.quantity}, Upsell Qty: ${upsellDetails.quantity}. Updating upsell.`);
              updates[upsellDetails.key] = mainItem.quantity; // Update by item.key
            }
          }
        });

        if (correspondingUpsellKey) {
            upsellItemsMap.delete(correspondingUpsellKey); // Remove processed upsell from map
        } else if (mainItem.quantity > 0) {
          // This case means a main personalisable item exists, but its upsell is missing or not identified.
          // This shouldn't happen if the initial add was successful and properties are correct.
          logError(`CRITICAL: Main item ${mainItem.title} (LID ${mainItem.linking_id}) Qty ${mainItem.quantity} has no identified linked upsell in cart for quantity sync.`);
        }
      });
  
      // Any remaining items in upsellItemsMap are orphaned (main item was removed or is not personalisable)
      upsellItemsMap.forEach(orphanedUpsell => {
        logDebug(`Orphaned upsell ${orphanedUpsell.title} (LID ${orphanedUpsell.linking_id}) Qty ${orphanedUpsell.quantity}. Setting to 0.`);
        updates[orphanedUpsell.key] = 0; // Update by item.key
      });
  
      if (Object.keys(updates).length > 0) {
        logDebug('Preparing to update cart quantities with changes:', updates);
        isUpdatingCartBySync = true;
        
        const requestBody = { updates: updates };
        const sectionsToRequest = [];
        
        // Always try to get cart drawer section for updates if its ID is known
        if (cartDrawerSectionId) {
            sectionsToRequest.push(cartDrawerSectionId);
        }

        // If on cart page and cart page section ID is known, request it too
        if (cartPageSectionId && window.location.pathname.includes('/cart')) {
            if (!sectionsToRequest.includes(cartPageSectionId)) { // Avoid duplicates
                sectionsToRequest.push(cartPageSectionId);
            }
        }

        if (sectionsToRequest.length > 0) {
            requestBody.sections = sectionsToRequest;
            requestBody.sections_url = window.location.pathname;
        }
        logDebug('Cart update.js request body:', requestBody);

        try {
          const response = await fetch(`${Shopify.routes.root}cart/update.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(requestBody)
          });
          const updatedCartData = await response.json();
          if (!response.ok) {
            logError('Failed to update cart for sync:', updatedCartData.message || updatedCartData.description || 'Unknown error');
          } else {
            logDebug('Cart update.js successful for sync. Response cart:', updatedCartData);
            document.dispatchEvent(new CustomEvent("cart:change", {
                bubbles: true,
                detail: {
                  baseEvent: "cart:sync:update",
                  cart: updatedCartData, 
                  request_url: window.location.pathname, 
                  source: "lgx-cart-sync"
                }
              }));
            logDebug('Dispatched cart:change event after sync update.');
          }
        } catch (error) {
          logError('Error calling cart/update.js for sync:', error);
        } finally {
          setTimeout(() => {
            isUpdatingCartBySync = false;
            logDebug('isUpdatingCartBySync flag reset.');
          }, 750);
        }
      } else {
        logDebug('No synchronisation changes needed for the cart quantities.');
      }
      // No DOM marking function is called here anymore.
    }
  
    document.addEventListener('cart:change', function(event) {
      logDebug('cart:change event detected. Source:', event.detail && event.detail.source ? event.detail.source : 'theme/unknown', 'BaseEvent:', event.detail?.baseEvent);
      if (event.detail && event.detail.source === 'lgx-cart-sync') {
        logDebug('Skipping cart:change event triggered by this script (lgx-cart-sync).');
        return;
      }

      if (event.detail && event.detail.cart) {
        synchroniseCartItems(event.detail.cart);
      } else {
        logWarn('cart:change event - cart data missing. Fetching manually.');
        fetch(`${Shopify.routes.root}cart.js`)
          .then(response => response.json())
          .then(cartData => synchroniseCartItems(cartData))
          .catch(error => logError('Error fetching cart.js for sync:', error));
      }
    });
  
    function initialCartCheckAndSetup() {
      findCartDrawerSectionId();
      findCartPageSectionId(); // Added call
      logDebug('Attempting initial cart sync check.');
      fetch(`${Shopify.routes.root}cart.js`)
          .then(response => response.json())
          .then(cartData => {
              if (cartData && cartData.items) synchroniseCartItems(cartData);
              else if (cartData) logWarn('Initial cart fetch successful but no items array in cartData:', cartData);
              else logWarn('Initial cart fetch returned no cartData.');
          })
          .catch(error => logError('Error fetching cart.js for initial sync:', error));

      // Add listeners for proactive updates
      // Need to ensure these forms exist. Check for them before adding listeners.
      const cartForms = document.querySelectorAll('form[action="/cart/change"], form[action="/cart/update.js"], form#CartDrawer-Form, form#Cart-Form, form.cart'); // Common selectors
      
      cartForms.forEach(form => {
        logDebug('[InitialSetup] Attaching proactive listeners to form:', form.id || form.className || form);
        form.addEventListener('change', handlePotentialLinkedItemChange, true); // Capture phase for quantity inputs
        form.addEventListener('click', handlePotentialLinkedItemChange, true); // Capture phase for remove buttons (delegated)
      });
      if(cartForms.length === 0) {
        logWarn("No cart forms found for proactive listeners. Relying on fallback 'cart:change' synchronization.");
      }
    }
  
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialCartCheckAndSetup);
    } else {
      initialCartCheckAndSetup();
    }
    logDebug('LGX Cart Sync script loaded and initialised (DOM marking removed).');
  })();
  